import { mutator } from 'satcheljs';
import getStore from '../store/store';
import deleteService from '../actions/deleteService';

/**
 * Delete a service from the store.
 */
export default mutator(deleteService, actionMessage => {
    let store = getStore();

    for (var i = 0; i < store.services.length - 1; i++) {
        if (store.services[i].ItemId.Id === actionMessage.itemId.Id) {
            store.services.splice(i, 1);
            break;
        }
    }
});
